import { MAX_COLUMN } from "../../global";

// dynamictabale head and body table type = 1 (IR), type=2(manual cover letter), type=3(edit cover letter)

// Utility to generate headers for saving
export const extractHeaders = (table, jobInspectionId, type) =>
  table.header.map(({ label, colRelation }) => ({
    jobInspectionId,
    label,
    colRelation,
    type
  }));

// Utility to generate body rows for saving (only with valid data)
export const extractBodyRows = (table, jobInspectionId, type) =>
  table.body
    .filter((row) =>
      Object.keys(row).some(
        (key) => key.startsWith("c") && row[key]?.toString().trim() !== ""
      )
    )
    .map((row) => {
      const result = { jobInspectionId, type };
     // Include ALL columns up to MAX_COLUMN to ensure equal keys
      for (let i = 1; i <= MAX_COLUMN; i++) {
        const key = `c${i}`;
        result[key] = row[key]?.toString().trim() || null;
      }
      return result;
    });

// Utility to group fetched table data
export const groupTableData = (headers, bodyData, jobId) => {
  const table = {
    id: jobId,
    header: [],
    columns: [],
    body: [],
  };

  headers
    .sort(
      (a, b) =>
        parseInt(a.colRelation.replace("c", "")) -
        parseInt(b.colRelation.replace("c", ""))
    )
    .forEach((header) => {
      table.header.push(header);
      table.columns.push({
        id: header.colRelation,
        accessor: header.colRelation,
        label: header.label,
      });
    });

  const body = bodyData.map((row) => {
    const rowData = { jobInspectionId: row.jobInspectionId };
    for (let i = 1; i <= MAX_COLUMN; i++) {
      const key = `c${i}`;
      if (key in row) rowData[key] = row[key] || "";
    }
    return rowData;
  });

  table.body =
    body.length > 0
      ? body
      : [
          {
            jobInspectionId: jobId,
            ...Object.fromEntries(
              [...Array(MAX_COLUMN)].map((_, i) => [`c${i + 1}`, ""])
            ),
          },
        ];

  return [table];
};
